import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { NgOtpInputModule } from 'ng-otp-input';
import { MaterialModule } from 'src/app/material.module';
import { OtpVerificationComponent } from 'src/app/modules/claim/claim-management/third-party-registered-garages/otp-verification/otp-verification.component';
import { RegisteredGarageAssignmentActionComponent } from 'src/app/modules/claim/claim-management/third-party-registered-garages/registered-garage-assignment-action/registered-garage-assignment-action.component';
import { RegisteredGarageRequestEstimateActionComponent } from 'src/app/modules/claim/claim-management/third-party-registered-garages/registered-garage-request-estimate-action/registered-garage-request-estimate-action.component';
import { RegisteredGarageRequestInvoiceActionComponent } from 'src/app/modules/claim/claim-management/third-party-registered-garages/registered-garage-request-invoice-action/registered-garage-request-invoice-action.component';
import { ThirdPartyCommonLayoutComponent } from 'src/app/modules/claim/claim-management/third-party-registered-garages/common-layout/common-layout.component';
import { VerifyOtpComponent } from 'src/app/modules/claim/claim-management/third-party-registered-garages/verify-otp/verify-otp.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { WidgetsModule } from 'src/app/widgets/widgets.module';

/**
 * Eager module for unauthenticated claim OTP / garage-action routes in app-routing
 * (no MsalGuard). Keeps `translate` and widget selectors available without loading
 * the lazy claim feature modules (NG0302).
 */
@NgModule({
  declarations: [
    ThirdPartyCommonLayoutComponent,
    OtpVerificationComponent,
    VerifyOtpComponent,
    RegisteredGarageAssignmentActionComponent,
    RegisteredGarageRequestEstimateActionComponent,
    RegisteredGarageRequestInvoiceActionComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    TranslateModule,
    WidgetsModule,
    SharedModule,
    MaterialModule,
    NgOtpInputModule
  ],
  exports: [
    ThirdPartyCommonLayoutComponent,
    OtpVerificationComponent,
    VerifyOtpComponent,
    RegisteredGarageAssignmentActionComponent,
    RegisteredGarageRequestEstimateActionComponent,
    RegisteredGarageRequestInvoiceActionComponent
  ]
})
export class PublicClaimActionsModule {}
